import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentSetBackground } from '@sorare/core/src/set/branding/useCurrentSetBackground.ts';

import defaultBackground from './assets/default.webp';

const Root = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
  rarityColor?: string;
  rarity: Rarity;
};
export const Background = ({ golden, rarityColor, rarity }: Props) => {
  const setBackground = useCurrentSetBackground();

  const baseBg =
    rarity === Rarity.common && setBackground
      ? `url(${setBackground}) no-repeat center center / cover`
      : `url(${defaultBackground}) no-repeat center center / cover`;

  const layers = [
    golden
      ? 'linear-gradient(#FFC534, #FFC534)'
      : 'linear-gradient(transparent, transparent)',
    ...(rarityColor ? [`linear-gradient(${rarityColor}, ${rarityColor})`] : []),
    baseBg,
  ];
  const blendModes = [
    'color',
    ...(rarityColor ? ['soft-light'] : []),
    'normal',
  ];

  return (
    <Root
      style={
        {
          background: layers.join(', '),
          backgroundBlendMode: blendModes.join(', '),
        } as CSSProperties
      }
    />
  );
};
